var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.6119,
    height: 18.6119,
    transform: "translate(0.116211 0.328125)",
    fill: "#445386"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8533 5.90945C16.6749 5.2378 16.1493 4.70883 15.482 4.52932C14.2725 4.20312 9.42242 4.20312 9.42242 4.20312C9.42242 4.20312 4.57237 4.20312 3.36281 4.52932C2.69551 4.70886 2.16995 5.2378 1.99157 5.90945C1.66748 7.12684 1.66748 9.66683 1.66748 9.66683C1.66748 9.66683 1.66748 12.2068 1.99157 13.4242C2.16995 14.0959 2.69551 14.6028 3.36281 14.7823C4.57237 15.1085 9.42242 15.1085 9.42242 15.1085C9.42242 15.1085 14.2725 15.1085 15.482 14.7823C16.1493 14.6028 16.6749 14.0959 16.8533 13.4242C17.1774 12.2068 17.1774 9.66683 17.1774 9.66683C17.1774 9.66683 17.1774 7.12684 16.8533 5.90945ZM7.83617 11.9729V7.36071L11.8899 9.66689L7.83617 11.9729Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-Icon.c0c307e542ef5e2a2f49e078db825f29.svg";
export { ForwardRef as ReactComponent };